/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowClassic = $.extend(this, window.PXUTheme.getSectionData($section));

    // Reveal CLS-hidden cells before Flickity measures
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');
    $slideshowClassicEl.find('.gallery-cell.is-hidden').removeClass('is-hidden');

    const slideCount = $slideshowClassicEl.find('.gallery-cell').length;
    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: slideCount > 3,
      adaptiveHeight: true,
      prevNextButtons: slideCount > 1 ? this.show_arrows : false,
      pageDots: slideCount > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape
    });

  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;
